import { render, staticRenderFns } from "./AssignBranchModal.vue?vue&type=template&id=b995acf2&"
import script from "./AssignBranchModal.vue?vue&type=script&lang=js&"
export * from "./AssignBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports